import { render, staticRenderFns } from "./DictionaryItemManage.vue?vue&type=template&id=2233f5e2&"
import script from "./DictionaryItemManage.vue?vue&type=script&lang=js&"
export * from "./DictionaryItemManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports